import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useExperiment } from '@fs/zion-experiments'
import { boolAttr } from '@fs/zion-frontend-friends'
import { useHistory } from '@fs/zion-router'
import { colors, useAtSize, WhiteText } from '@fs/zion-ui'
import { getCachedSearchParams, setCachedSearchParams } from '../../services/search-service'
import Search from '../search/Search'
import AncestorSocial from './AncestorSocial'
import { Person } from '../../types/persons'

const footerContainerCss = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 44px 20px 44px;
  align-items: center;
  position: relative;
  width: 100%;

  /* TEMPORARY: Should be removed once zion-ui WhiteText is updated to handle validation text. This overrides the validation red to white so it is readable. */
  --feedback-danger-text: ${colors.billboard.gray00};

  &[is-mobile] {
    padding: 44px 20px 20px;
  }
`

const backgroundMap = {
  FEMALE: { start: colors.billboard.red25, end: colors.billboard.red40 },
  MALE: { start: colors.billboard.blue30, end: colors.billboard.blue40 },
  UNKNOWN: { start: colors.billboard.yellow25, end: colors.billboard.yellow40 },
}

export default function AncestorsPageFooter({
  person,
  analytics = {},
}: {
  person: Person
  analytics: Record<string, string>
}): JSX.Element {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const isMobile = atSize({ lg: false, default: true })
  const history = useHistory()
  const initialParams = getCachedSearchParams()

  function onSearchSubmit(params: Record<string, string>): void {
    setCachedSearchParams(params)
    history.push('/search')
  }

  const background = `linear-gradient(${isMobile ? '126deg' : '90deg'}, ${backgroundMap[person.gender].start} 0%, ${
    backgroundMap[person.gender].end
  } ${isMobile ? '100%' : '33.44%'})`

  return (
    <WhiteText>
      <div css={footerContainerCss} is-mobile={boolAttr(atSize({ lg: false, default: true }))} style={{ background }}>
        <Search
          header={t('ancestors.search-for-another-ancestor.header', 'Search for Another Deceased Ancestor')}
          onSubmit={onSearchSubmit}
          params={initialParams}
          analytics={{ link_page: 'Person: Footer' }}
        />
        <AncestorSocial person={person} analytics={analytics} />
      </div>
    </WhiteText>
  )
}
